import { apiClient } from '../../../api/client';
import { handleApiError } from '../../../api/errorHandler';

import { GetDevicesResponse } from './types';

export const getDevices = async (): Promise<GetDevicesResponse> => {
  try {
    const response = await apiClient.get<GetDevicesResponse>('/devices/');
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
